<script setup lang="ts">
    import {computed} from 'vue';
    import useCpBem from '~/composables/useCpBem';
    import google from '~/assets/img/google_logo.svg';
    import x from '~/assets/img/x_logo.svg';
    import facebook from '~/assets/img/facebook_logo.svg';
    import discord from '~/assets/img/discord_logo.svg';
    import apple from '~/assets/img/apple.svg';
    import tiktok from '~/assets/img/tiktok.svg';

    const props = defineProps<{
        /** Custom description */
        kind: 'google'|'x'|'facebook'|'discord'|'apple'|'tiktok'
    }>();

    const img = {
        google,
        x,
        facebook,
        discord,
        apple,
        tiktok,
    };

    const src = computed(() => img[props.kind]);

    const {b} = useCpBem('cp-partner-logo');
</script>

<template>
    <div :class="b">
        <img :src="src" :alt="kind">
    </div>
</template>

<style scoped lang="scss">
    .cp-partner-logo {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: space-around;
    }
</style>
